<template>
	<div style="background-color: #fff;padding: 15px;">
		<div class="row justify-content-center">
			<div class="col-lg-12">
				<div class="table-box" style="padding: 0 10px;">
					<el-empty v-if="dataList.length==0" description="暂无数据"></el-empty>
					<table v-else class="table transaction-table">
						<thead>
							<tr>
								<th class="text-center" scope="col">序号</th>
								<th class="text-center" scope="col">产品名称</th>
								<th class="text-center" scope="col">单价</th>
								<th class="text-center" scope="col">数量</th>
								<th class="text-center" scope="col">总价格</th>
								<th class="text-center" scope="col">订单状态</th>
								<th class="text-center" scope="col">创建时间</th>
								<th class="text-center" scope="col">操作</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item,index) in dataList" :key="index">
								<th class="text-center" scope="row">
									<p class="text">{{index+1}}</p>
								</th>
								<td class="text-center">
									<p class="text">{{item.title}}</p>
								</td>
								<td class="text-center">
									<p class="text">{{item.productSellPrice}}元</p>
								</td>
								<td class="text-center">
									<p class="text">{{item.productCount}}</p>
								</td>
								<td class="text-center">
									<p class="text">{{item.productTotal}}元</p>
								</td>
								<td class="text-center">
									<el-tag :type="typeInfo[item.orderStatus]">
										{{item.orderStatus}}
									</el-tag>
								</td>
								<td class="text-center">
									<p class="text">{{item.createTime}}</p>
								</td>

								<td class="text-center">
									<el-button @click="toDetail(item)" type="text">详情</el-button>
									<el-button v-if="item.codeUrl&&item.orderStatus=='未支付'" type="text" @click="toCode(item)">重新支付</el-button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="total>0" style="text-align: center;margin-top: 15px;">
					<el-pagination background @current-change="getList" :current-page.sync="queryParams.pageNum"
						:page-size="queryParams.pageSize" layout="total, prev, pager, next" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<b-modal ref="my-modal" title="订单详情">
			<div style="color: #FA8936;font-size: 16px;line-height: 1.62;font-weight: 700;" v-if="orderInfo.sxmCode">
				苏学码：<span id="target">{{orderInfo.sxmCode}}</span><el-button style="margin-left: 15px;" type="text"
					@click="handleCopy" class="btnnn" data-clipboard-target="#target">复制</el-button></div>
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<div class="mini-title">商品信息</div>
				<div>
					<img v-if="orderInfo.orderStatus=='用户已取消'" class="bannerPay" src="@/assets/images/cancel.png" />
					<img v-if="orderInfo.orderStatus=='超时已关闭'" class="bannerPay" src="@/assets/images/close.png" />
					<img v-if="orderInfo.orderStatus=='支付成功'" class="bannerPay" src="@/assets/images/pay.png" />
					<img v-if="orderInfo.orderStatus=='未支付'" class="bannerPay" src="@/assets/images/unpay.png" />
				</div>
			</div>
			<div class="pop-item">
				<div class="pop-name">产品名称：</div>
				<div class="pop-value">{{orderInfo.title}}</div>
			</div>
			<div class="pop-item">
				<div class="pop-name">单价：</div>
				<div class="pop-value">{{orderInfo.productSellPrice}}元</div>
			</div>
			<div class="pop-item">
				<div class="pop-name">数量：</div>
				<div class="pop-value">{{orderInfo.productCount}}</div>
			</div>
			<div class="pop-item">
				<div class="pop-name">总价格：</div>
				<div class="pop-value">{{orderInfo.productTotal}}元</div>
			</div>
			<div class="pop-item">
				<div class="pop-name">创建时间：</div>
				<div class="pop-value">{{orderInfo.createTime}}</div>
			</div>
			<div class="mini-title">配送信息</div>
			<div class="pop-item">
				<div class="pop-name">收件人：</div>
				<div class="pop-value">{{orderInfo.dispatchReceiver}}</div>
			</div>
			<div class="pop-item">
				<div class="pop-name">邮箱：</div>
				<div class="pop-value">{{orderInfo.dispatchEmail}}</div>
			</div>
			<div class="pop-item">
				<div class="pop-name">手机号码：</div>
				<div class="pop-value">{{orderInfo.productPhone}}</div>
			</div>
			<template v-slot:modal-footer="{ ok, cancel, hide }">
				<b-button variant="success" @click="cancel()">
					确定
				</b-button>
				<b-button variant="danger" @click="cancel()">
					取消
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
	import {
		orderList
	} from "@/api/userCenter";
	export default {
		data() {
			return {
				queryParams: {
					pageNum: 1,
					pageSize: 10
				},
				total: 0,
				dataList: [],
				orderInfo: {},
				typeInfo:{
					"未支付":'warning',
					"支付成功":'success',
					"超时已关闭":'danger',
					"用户已取消":'danger',
					"退款中":'primary',
					"已退款":'success',
					"退款异常":'danger',
				}
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList() {
				orderList(this.queryParams).then(res => {
					this.dataList = res.rows
					this.total = res.total;
				})
			},
			toCode(item) {
				this.$router.push({
					path: "/payCode",
					query: {
						code: item.codeUrl,
						price: item.productTotal,
						orderNo: item.orderNo
					}
				})
			},
			toDetail(item) {
				this.orderInfo = item
				this.$refs['my-modal'].show()
			},
			handleCopy() {
				let clipboard = new this.clipboard(".btnnn");
				let that = this
				that.$message({
					showClose: true,
					type: 'success',
					message: '复制成功！'
				})
			},
		}
	}
</script>
<style>
	/*带背景的分页按钮背景色begin*/
	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #547af8;
		color: #FFF;
	}

	.el-pagination.is-background .el-pager li.active {
		color: #fff;
		cursor: default;
	}

	.el-pagination.is-background .el-pager li:hover {
		color: #547af8;
	}

	.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #547af8;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
		background-color: #547af8;
		color: #FFF;
	}
</style>
<style lang="scss" scoped>
	.pop-item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 10px;

		.pop-name {
			// font-size: 15px;
			// font-family: Microsoft YaHei;
			// font-weight: bold;
			// color: #333333;
			// width: 20%;
			display: flex;
			justify-content: flex-end;
		}

		.pop-value {}
	}

	.mini-title {
		padding-left: 15px;
		position: relative;
		margin: 10px 0;
		font-weight: 600;
	}

	.mini-title::after {
		content: "";
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 0;
		width: 5px;
		height: 20px;
		background-color: #007BFF;
		border-radius: 5px;
	}

	.bannerPay {
		width: 55px;
		height: 55px;
	}
</style>